import { useCallback, useState } from 'react'

const EXPIRY_DATE = new Date('2026-08-01')

export function useDismissible(storageKey: string) {
  const [dismissed, setDismissed] = useState(() => {
    if (new Date() >= EXPIRY_DATE) return true
    return sessionStorage.getItem(storageKey) === 'true'
  })

  const dismiss = useCallback(() => {
    sessionStorage.setItem(storageKey, 'true')
    setDismissed(true)
  }, [storageKey])

  return [dismissed, dismiss] as const
}
